module.exports = __webpack_public_path__ + "img/solution1_banner_txt.6d89f38c.png";